import * as units from './index'

export default {
  humans: [
    units.archer,
    units.barbarian,
    units.catapult,
    units.cleric,
    units.horseman,
    units.knight,
    units.mage,
    units.warrior,
  ],
  monsters: [
    units.bat,
    units.demon,
    units.dragon,
    units.giant,
    units.orc,
    units.orcArcher,
    units.spider,
    units.troll,
  ],
}



// WEBPACK FOOTER //
// ./src/engine/units/races.ts